<template>
  <div class="nav nav--footer" v-if="footerMenus">

    <template v-for="(item, i) in footerMenus?.data" :key="i">
      <NuxtLink :to="localePath(item.url)" prefetch-on="interaction" class="nav-link" :target="item.target">
        {{ item.name }}
      </NuxtLink>
    </template>
  </div>
</template>

<script setup>

import { useMenuServiceStore } from '@/stores/menuService.js';

const menuStore = useMenuServiceStore();
const { fetchMenu } = menuStore;

// ดึง footer menu
const menus = await fetchMenu("/footer");
const footerMenus = menus['/footer'];

</script>

<style lang="scss" scoped>
@import "@/assets/scss/app";

@each $lang in $languages {
  html[lang="#{$lang}"] {
    .nav {
      &.nav--footer {
        .nav-link {
          @include font-size("h4", $lang);
          @include font-weight("medium", $lang);
        }
      }
    }
  }
}

.nav {
  &.nav--footer {
    display: flex;
    gap: 14px 40px;

    @include media-breakpoint-down(lg) {
      gap: 14px 30px;
    }

    @include media-breakpoint-down(md) {
      gap: 14px 20px;
    }

    .nav-link {
      padding: 0;
      color: $white;
      text-decoration: none;
      @include transition();

      @include hover-focus-active {
        color: $green-1;
      }
    }

  }
}
</style>
